<div class="right-margin">
    <button class="close-icon" (click)="closeDialog()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
    <h2>{{declineTitle}}</h2>
    <div>{{declineMessage}}</div>
    <div style="width: 100%;">
       <textarea name="declineReasosns" [(ngModel)]="declineReasons"></textarea>
    </div>
    <div class="block-buttons">
       <button type="button" (click)="confirm()">{{declineButton}}</button>
    </div>
</div>